import React from 'react';
import { useChat } from '../context/ChatProvider';
import { FaWhatsapp, FaGlobe, FaFacebookMessenger, FaTimes } from 'react-icons/fa';

// ===================================================================================
// A. Channel Icon Component (No changes needed)
// ===================================================================================
const ChannelIcon = ({ channel, className }) => {
    switch (channel) {
        case 'whatsapp': return <FaWhatsapp className={className} />;
        case 'messenger': return <FaFacebookMessenger className={className} />;
        case 'web':
        default:
            return <FaGlobe className={className} />;
    }
};

// ===================================================================================
// B. The Main Active Conversations Panel Component (Definitive Fix)
// ===================================================================================
export function ActiveConversationsPanel() {
    const { conversations, activeConversation, viewConversation, endChat } = useChat();

    // Guard clause for when the conversations array itself is not yet initialized.
    if (!conversations) {
        return (
            <div className="flex-shrink-0 p-4">
                <div className="text-sm text-slate-500">Initializing chats...</div>
            </div>
        );
    }

    return (
        <div className="flex-shrink-0 p-2">
            <div className="flex overflow-x-auto">
                {conversations.length === 0 ? (
                    <div className="px-4 py-3 text-sm text-slate-500">No active chats.</div>
                ) : (
                    // --- THE DEFINITIVE BUG FIX ---
                    // We now filter the array *before* mapping. This removes any invalid conversation
                    // objects (e.g., null, undefined, or those missing an 'id' property) to prevent the .slice() error.
                    conversations
                        .filter(convo => convo && convo.id) 
                        .map((convo) => {
                            const isActive = activeConversation?.id === convo.id;
                            return (
                                <div
                                    key={convo.id}
                                    onClick={() => viewConversation(convo.id)}
                                    className={`relative flex items-center gap-3 px-4 py-3 rounded-t-lg cursor-pointer transition-colors duration-200 flex-shrink-0 border-b-2 ${
                                        isActive
                                            ? 'bg-slate-700/50 border-cyan-400'
                                            : 'border-transparent hover:bg-slate-700/50'
                                    }`}
                                >
                                    <ChannelIcon channel={convo.channel} className={`text-lg ${isActive ? 'text-cyan-400' : 'text-slate-400'}`} />
                                    <div className="flex-1 overflow-hidden">
                                        <p className={`text-sm font-semibold truncate ${isActive ? 'text-white' : 'text-slate-300'}`}>
                                            User: ...{convo.id.slice(-12)}
                                        </p>
                                    </div>
                                    
                                    {convo.unreadCount > 0 && (
                                        <span className="ml-2 text-xs font-bold text-white bg-red-600 rounded-full w-5 h-5 flex items-center justify-center">
                                            {convo.unreadCount}
                                        </span>
                                    )}

                                    <button
                                        onClick={(e) => { e.stopPropagation(); endChat(convo.id); }}
                                        className="ml-2 p-1.5 rounded-full text-slate-500 hover:bg-red-500/20 hover:text-red-400 transition-colors"
                                        aria-label="End this chat"
                                    >
                                        <FaTimes size={12} />
                                    </button>
                                </div>
                            );
                        })
                )}
            </div>
        </div>
    );
}